import React from "react";
import styles from "../DescribeBusiness.module.css";
import TextArea from "uicomponents/TextArea";
import RadioInput from "uicomponents/RadioInput";
import DocumentUpload from "uicomponents/DocumentUpload";
import { sectionsQuestions } from "pages/WorkersCompApplcation/utils/sectionsQuestions";
import { BusinessDescriptionType } from "types";
import WebsiteInput from "./WebsiteInput";
import { FieldArray } from "formik";
import { DescribeBusinessFormType } from "pages/WorkersCompApplcation/utils/formType";
import { SystemIcon } from "@justworkshr/milo-components";

interface IDescribeBusinessComponentProps {
  data?: BusinessDescriptionType;
  formValues: DescribeBusinessFormType;
  fieldRefs: React.MutableRefObject<{ [key: string]: HTMLInputElement | null }>;
}

const DescribeBusinessComponent = ({
  ...props
}: IDescribeBusinessComponentProps): JSX.Element => {
  const { data, formValues, fieldRefs } = props;
  const {
    questions: labelList,
    message: messageList,
    placeholder: placeholderList,
  } = sectionsQuestions["aboutYourBusiness"];

  return (
    <div>
      <div className={styles.title}>
        {sectionsQuestions["aboutYourBusiness"].title}
      </div>
      <div className={styles.description}>
        {sectionsQuestions["aboutYourBusiness"].description}
      </div>
      <TextArea
        name="businessDescription"
        label={labelList.businessDescription}
        message={messageList.businessDescription}
        placeholder={placeholderList.businessDescription}
        fieldRefs={fieldRefs}
      />

      <FieldArray
        name="website"
        render={(arrayHelpers) => {
          return (
            <div className={styles.websiteWrapper}>
              {formValues.website.map((_, index: number) => {
                const isFirstInput = index === 0;

                return (
                  <WebsiteInput
                    key={`${index}`}
                    name={`website[${index}]`}
                    label={isFirstInput ? labelList.website : ""}
                    message={isFirstInput ? messageList.companyUrl : undefined}
                    onDelete={() => {
                      arrayHelpers.remove(index);
                      if (formValues.website.length === 1) {
                        arrayHelpers.push("");
                      }
                    }}
                    fieldRefs={fieldRefs}
                  />
                );
              })}
              <button
                className={styles.addLink}
                data-testid="add-website-link"
                type="button"
                onClick={() => {
                  arrayHelpers.push("");
                }}
              >
                <SystemIcon iconName="plus" size="small" color="brand" />
                add link
              </button>
            </div>
          );
        }}
      />

      <DocumentUpload
        name="verifyCompanyUrl"
        label={labelList.verifyCompanyUrl}
        required={false}
        application={data?.applications?.[0]}
      />
      <TextArea
        name="dailyOperationsOfEmployees"
        label={labelList.dailyOperationsOfEmployees}
        message={messageList.dailyActivities}
        placeholder={placeholderList.dailyActivities}
        fieldRefs={fieldRefs}
      />
      <RadioInput
        name="hasUnionWorkers"
        label={labelList.hasUnionWorkers}
        options={["Yes", "No"]}
        fieldRefs={fieldRefs}
      />
    </div>
  );
};

export default DescribeBusinessComponent;
